var React = require('react');

function LogoNuxt (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.3564 5.52486C11.5719 4.17597 9.61059 4.17595 8.82608 5.52486L0.276112 20.2259C-0.508402 21.5748 0.472237 23.2609 2.04126 23.2609H8.71586C8.0454 22.675 7.79713 21.6613 8.30448 20.7917L14.7798 9.69179L12.3564 5.52486Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M17.7741 8.74962C18.4233 7.64596 20.0465 7.64596 20.6957 8.74962L27.7714 20.7777C28.4208 21.8813 27.6093 23.2609 26.3108 23.2609H12.159C10.8606 23.2609 10.049 21.8813 10.6982 20.7777L17.7741 8.74962Z","fill":"currentColor","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"28","height":"28","fill":"white"})))]);
}

LogoNuxt.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = LogoNuxt;

LogoNuxt.default = LogoNuxt;
